import styled from '@emotion/styled'

import { container, spacing } from 'main/ui'

export const MapContainer = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
`

export const FixedCalloutContainer = styled.div<{ padding: { bottom: number } }>`
  bottom: ${({ padding }) => padding.bottom + spacing.majorScale(3)}px;
  left: ${spacing.majorScale(3)}px;
  margin-left: auto;
  margin-right: auto;
  max-width: ${container.maxWidth.sm}px;
  position: absolute;
  right: ${spacing.majorScale(3)}px;
  z-index: 1;
`
